// src/apis/profile.ts
// Profile API 模块

import service from '@/utils/https';
import type { AxiosResponse } from 'axios';
import type { ProfileUpdateRequest, PreferencesUpdateRequest, ChangePasswordRequest, UploadAvatarRequest, SetProfileCVRequest, ProfileResponse } from '@/types/profile';
import type { ApiResponse } from '@/types';
import type { FileUploadUrlRequest, PresignedUploadUrlResponse } from '@/types/aws';

// 获取个人资料
export function getProfile(): Promise<AxiosResponse<ApiResponse<ProfileResponse>>> {
  return service({
    url: '/v1/profile',
    method: 'get',
  });
}

// 更新个人资料
export function updateProfile(data: ProfileUpdateRequest): Promise<AxiosResponse<ApiResponse<ProfileResponse>>> {
  return service({
    url: '/v1/profile',
    method: 'patch',
    data,
  });
}

// 更新偏好设置
export function updatePreferences(data: PreferencesUpdateRequest): Promise<AxiosResponse<ApiResponse<void>>> {
  return service({
    url: '/v1/profile/preferences',
    method: 'patch',
    data,
  });
}

// 修改密码
export function changePassword(data: ChangePasswordRequest): Promise<AxiosResponse<ApiResponse<void>>> {
  return service({
    url: '/v1/profile/change-password',
    method: 'post',
    data,
  });
}

// 上传头像
export function uploadAvatar(data: UploadAvatarRequest): Promise<AxiosResponse<ApiResponse<void>>> {
  return service({
    url: '/v1/profile/avatar',
    method: 'post',
    data,
  });
}

// 获取头像上传 URL
export function getAvatarUploadUrl(data: FileUploadUrlRequest): Promise<AxiosResponse<ApiResponse<PresignedUploadUrlResponse>>> {
  return service({
    url: '/v1/profile/avatar-upload-url',
    method: 'post',
    data,
  });
}

// 设置个人简历
export function setProfileCV(data: SetProfileCVRequest): Promise<AxiosResponse<ApiResponse<void>>> {
  return service({
    url: '/v1/profile/cv',
    method: 'post',
    data,
  });
}

// 删除账户
export function deleteAccount(): Promise<AxiosResponse<ApiResponse<void>>> {
  return service({
    url: '/v1/profile',
    method: 'delete',
  });
}
